import * as actionTypes from "../types";
import * as firebase from "../../utils/firebase";
import { onSnapshot } from "firebase/firestore";





export const getTransactions = () => async (dispatch) => {
    try {
        onSnapshot(firebase.getTransactions(), request => {
            var requests = [];
            var books = []
            request.forEach((doc) => {
                requests.unshift({ ...doc.data(), id: doc.id })
                books.push(doc.data().bookBorrowed)
            });
            if (requests.length > 0) {
                dispatch({
                    type: actionTypes.GET_TRANSACTIONS,
                    payload: {
                        transactions: requests,
                        transactionEmpty: false,
                        bookID: books
                    }
                });
            } else {
                dispatch({
                    type: actionTypes.GET_TRANSACTIONS,
                    payload: {
                        transactions: requests,
                        transactionEmpty: true,
                        bookID: books
                    }
                });
            }
        })
    } catch (err) {
        console.error(err);
    }
}

export const getReturnedTransactions = () => async (dispatch) => {
    try {
        onSnapshot(firebase.getReturnedTransactions(), request => {
            var requests = [];
            var books = []
            request.forEach((doc) => {
                requests.unshift({ ...doc.data(), id: doc.id })
                books.push(doc.data().bookBorrowed)
            });
            if (requests.length > 0) {
                dispatch({
                    type: actionTypes.GET_RETURNED_TRANSACTIONS,
                    payload: {
                        transactions: requests,
                        transactionEmpty: false,
                        bookID: books
                    }
                });
            } else {
                dispatch({
                    type: actionTypes.GET_RETURNED_TRANSACTIONS,
                    payload: {
                        transactions: requests,
                        transactionEmpty: true,
                        bookID: books
                    }
                });
            }
        })
    } catch (err) {
        console.error(err);
    }
}

export const getPenaltyTransactions = () => async (dispatch) => {
    try {
        onSnapshot(firebase.getPenaltyTransactions(), request => {
            var requests = [];
            var books = []
            request.forEach((doc) => {
                    requests.unshift({ ...doc.data(), id: doc.id })
                    books.push(doc.data().bookBorrowed)
            });
            if (requests.length > 0) {
                dispatch({
                    type: actionTypes.GET_PENALTY_TRANSACTIONS,
                    payload: {
                        transactions: requests,
                        transactionEmpty: false,
                        bookID: books
                    }
                });
            } else {
                dispatch({
                    type: actionTypes.GET_PENALTY_TRANSACTIONS,
                    payload: {
                        transactions: requests,
                        transactionEmpty: true,
                        bookID: books
                    }
                });
            }
        })
    } catch (err) {
        console.error(err);
    }
}


export const getTransactBooks = (bookArray) => async (dispatch) => {
    try {
        if (bookArray.length > 0) {
            onSnapshot(firebase.getBooks(), request => {
                var books = [];
                request.forEach((doc) => {
                    for(var x=0; x<bookArray.length; x++){
                        if(bookArray[x] === doc.data().bookID) books.push({ ...doc.data(), id: doc.id })
                    }
                });
                if (books.length > 0) {
                    dispatch({
                        type: actionTypes.GET_TRANSACT_BOOKS,
                        payload: {
                            borrowedBooks: books,
                            borrowedBooksEmpty: false
                        }
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_TRANSACT_BOOKS,
                        payload: {
                            borrowedBooks: books,
                            borrowedBooksEmpty: true
                        }
                    });
                }
            })
        }
    } catch (err) {
        console.error(err);
    }
}

export const resetTransactions = () => async (dispatch) => {
    try {
        dispatch({
            type: actionTypes.RESET_TRANSACTIONS,
            payload: {
                borrowedBooks: [],
                borrowedBooksEmpty: false,
                borrowerDetails: [], 
                borrowerEmpty: false
            }
        });
    } catch (err) {
        console.error(err);
    }
}


//dashboard numbers
export const getNumber = () => async (dispatch) => {
    try {
        onSnapshot(firebase.getTransactions(), request => {
            if (request.size > 0) {
                dispatch({
                    type: actionTypes.GET_NUMBER,
                    payload: {
                        number: request.size,
                        numberEmpty: false
                    }
                });
            } else {
                dispatch({
                    type: actionTypes.GET_NUMBER,
                    payload: {
                        number: request.size,
                        numberEmpty: true
                    }
                });
            }
        })
    } catch (err) {
        console.error(err);
    }
}

export const getPenaltyNumber = () => async (dispatch) => {
    try {
        onSnapshot(firebase.getPenaltyTransactions(), request => {
            if (request.size > 0) {
                dispatch({
                    type: actionTypes.GET_LATE_NUMBER,
                    payload: {
                        number: request.size,
                        numberEmpty: false
                    }
                });
            } else {
                dispatch({
                    type: actionTypes.GET_LATE_NUMBER,
                    payload: {
                        number: request.size,
                        numberEmpty: true
                    }
                });
            }
        })
    } catch (err) {
        console.error(err);
    }
}
export const getReturnNumber = () => async (dispatch) => {
    try {
        onSnapshot(firebase.getReturnedTransactions(), request => {
            if (request.size > 0) {
                dispatch({
                    type: actionTypes.GET_RETURN_NUMBER,
                    payload: {
                        number: request.size,
                        numberEmpty: false
                    }
                });
            } else {
                dispatch({
                    type: actionTypes.GET_RETURN_NUMBER,
                    payload: {
                        number: request.size,
                        numberEmpty: true
                    }
                });
            }
        })
    } catch (err) {
        console.error(err);
    }
}
export const getRequestNumber = () => async (dispatch) => {
    try {
        onSnapshot(firebase.getRequests(), request => {
            if (request.size > 0) {
                dispatch({
                    type: actionTypes.GET_REQUEST_NUMBER,
                    payload: {
                        number: request.size,
                        numberEmpty: false
                    }
                });
            } else {
                dispatch({
                    type: actionTypes.GET_REQUEST_NUMBER,
                    payload: {
                        number: request.size,
                        numberEmpty: true
                    }
                });
            }
        })
    } catch (err) {
        console.error(err);
    }
}